import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import Loading from "./Loading";

function Indicadores() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [userPermissions, setUserPermissions] = useState([]);
    const [oldPermissions, setOldPermissions] = useState([]);
    const [client, setClient] = useState([]);

    // Función para verificar si el usuario tiene un permiso específico
    const hasPermission = (permissionSlug) => {
        // Verificar en el sistema nuevo (objetos)
        const checkNew = userPermissions.some(permission => permission.slug === permissionSlug);
        if (checkNew) return true;

        // Verificar en el sistema antiguo (strings)
        return oldPermissions.includes(permissionSlug);
    };

    useEffect(() => {
        if (localStorage.getItem('userdata')) {
            const userdata = JSON.parse(localStorage.getItem('userdata'));

            // Cargar permisos del sistema nuevo
            if (userdata.permissions && Array.isArray(userdata.permissions)) {
                setUserPermissions(userdata.permissions);
            }

            // Cargar permisos del sistema antiguo (fallback)
            if (userdata.up && Array.isArray(userdata.up)) {
                setOldPermissions(userdata.up);
            }

            setLoggedIn(true);
        }
    }, []);

    if (loggedIn) {
        return (
            <div className="hold-transition">
                <Header />
                <Aside activelink="indicators" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Indicadores</h1>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="row">
                                {/* RIPS - Solo mostrar si tiene permiso */}
                                {hasPermission('administrarRips') && (
                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>&nbsp;</h3>
                                                <p>RIPS</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-file-medical"></i>
                                            </div>
                                            <Link to="/listado-rips" className="small-box-footer">
                                                Ver Listado <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                )}

                                {/* RIPS Convenios - Solo mostrar si tiene permiso */}
                                {hasPermission('administrarRips') && (
                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-custom-dark">
                                            <div className="inner">
                                                <h3>&nbsp;</h3>
                                                <p>RIPS Convenios</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-file-invoice-dollar"></i>
                                            </div>
                                            <Link to="/rips-convenios" className="small-box-footer">
                                                Generar Facturas <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                )}

                                {/* Temperatura y Humedad - Solo mostrar si tiene permiso */}
                                {hasPermission('gestionarTemperaturaHumedad') && (
                                    <div className="col-lg-3 col-6">
                                        <div className="small-box bg-dark">
                                            <div className="inner">
                                                <h3>&nbsp;</h3>
                                                <p>Temperatura y Humedad</p>
                                            </div>
                                            <div className="icon">
                                                <i className="fas fa-thermometer-half"></i>
                                            </div>
                                            <Link to="/registros-temperatura-humedad" className="small-box-footer">
                                                Ver Registros <i className="fas fa-arrow-circle-right"></i>
                                            </Link>
                                        </div>
                                    </div>
                                )}

                                {/* Notas - Mantener sin validación por ahora */}
                                <div className="col-lg-3 col-6">
                                    <div className="small-box bg-warning">
                                        <div className="inner">
                                            <h3>&nbsp;</h3>
                                            <p>Notas</p>
                                        </div>
                                        <div className="icon">
                                            <i className="fas fa-sticky-note"></i>
                                        </div>
                                        <Link to="/administrar-notas" className="small-box-footer">
                                            Administrar <i className="fas fa-arrow-circle-right"></i>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer />
            </div>
        );
    }

    return (
        <Loading />
    );
}

export default Indicadores;
